function getUrlParameter(qs,name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(qs);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function logger(_label,_array) {
	try{
		_LOGGER_URL=(_URL) ? _URL + "/app/embed/logger_ajax.php" : null;

		if (_LOGGER_URL) {
	 		$.ajax({
            	type: "POST",
            	url: _LOGGER_URL,
            	timeout: 3000,
				data: { lbl: _label, arr: _array },
            	error: function(xhr,status,error) {
                	var errorMessage = xhr.status + ': ' + xhr.statusText + 'app/embed/logger_ajax.php';
                	console.log(errorMessage);
            	}
    		});
		}
	}
	catch (err) {
		console.log(err);
	}
}



/***************************************************************************/
/****************** BOT CUSTOM MENU   **************************************/
/***************************************************************************/

function getCustomBotMenu(_hash,_language) {
	try {
		_MENU_URL=(_URL) ? _URL + "/app/embed/get_botmenu.php" : null;

		if (_MENU_URL) {
        	$.ajax({
            	type: "POST",
            	url: _MENU_URL,
            	timeout: 0,
				data: { hash: _hash },
            	success: function(html) {
                	if (html) {
                		//console.log(html);
                    	$('#main-menu').removeClass('faq-content faq-content-main faq-content-all faq-content-active');
                    	$('#main-menu').addClass('faq-content faq-content-sub faq-content-submain');
                    	$('#main-menu').attr('data-previous','faq-content-main');
                    	$('#main-menu').attr('style','display: none');
                    	$('#custom-menu').addClass('faq-content faq-content-main faq-content-all faq-content-active');
                    	$('#custom-menu').html(html);
                    	$('.faq-content-drug, .faq-content-device, .faq-content-toxic, .faq-content-liability, .faq-content-work').attr('data-previous','faq-content-submain');
                	}
                	else {
                    	$('#custom-menu').attr('style','display: none');
                	}

					if (_language !== 'en-US') {
						translateMenu(_language);
					}
            	},
            	error: function(xhr,status,error) {
                	var errorMessage = xhr.status + ': ' + xhr.statusText + 'app/embed/get_botmenu.php';
                	console.log(errorMessage);
            	}
        	});
		}
	}
	catch (err) {
		console.log(err);
	}
}

function translateMenuItems(_textArray, _language) {

	_LANG_URL=(_URL) ? _URL + "/app/embed/translate.php" : null;
	SPANISH_CONSENT = 'Al hacer clic en "Recibir llamada ahora", acepto que un abogado se comunique conmigo. Afirmo que tengo 18 años o más y doy mi consentimiento para recibir mensajes o llamadas de mercadotecnia automatizados de este sitio web y entidades asociadas, y entiendo que esta autorización anula cualquier registro previo en un registro federal o estatal de “No Llame”. También acepto los';
	SPANISH_TERMS_CONDITIONS = 'Términos y Condiciones y la Póliza de Privacidad';
	if (_LANG_URL) {
		$.ajax({
			type: "POST",
			url: _LANG_URL,
			timeout: 0,
			data: { textArray: _textArray, language: _language },
			success: function(data) {
				var translateText = $.parseJSON(data);

				if (translateText) {
					$('.btn','.faq-content').not('.faq-content .faq-content-main .faq-content-popular').each(function() {
						$(this).text(translateText.shift());
					});

        			// $('.btn-previous','.header_text').html('<span><img src="./lib/fontawesome/svgs/light/long-arrow-left.svg" style="width:20px;height:10px"></span> ' + translateText.shift());
        			// $('.btn-previous','.chat-header').html('<span><img src="./lib/fontawesome/svgs/light/long-arrow-left.svg" style="width:20px;height:10px"></span>> ' + translateText.shift());
        			// $('.btn-restart').html(translateText.shift());
					$('.control-textarea').attr('placeholder', translateText.shift());
					$('.offcanvas-text').attr('placeholder', translateText.shift());
        			$('.offcanvas-cancel').text(translateText.shift());
        			$('.faq-content-footer-heading').text(translateText.shift());
					$('.btn-composer-submit').html(translateText.shift());

					$(".click-call-trigger.trigger-header-text").html(translateText.shift());
					$(".click-call-trigger.trigger-menu").html(translateText.shift());
					$(".text:nth-of-type(1)", ".click-call-controls").html(translateText.shift());
					$(".text:nth-of-type(2)", ".click-call-controls").html(translateText.shift());
					$(".contactFname", ".click-call-controls").attr('placeholder', translateText.shift());
					$(".contactLname", ".click-call-controls").attr('placeholder', translateText.shift());
					$(".contactPhone", ".click-call-controls").attr('placeholder', translateText.shift());
					$(".btnText", ".click-call-controls").html(translateText.shift());
					$(".text:nth-of-type(1)", ".click-call-unavailable").html(translateText.shift());
					$(".text:nth-of-type(2)", ".click-call-unavailable").html(translateText.shift());
					$(".consent-text", ".click-call-consent").html(_language == 'es-ES' ? SPANISH_CONSENT : translateText.shift());
					$(".policyButton", ".click-call-consent").html(_language == 'es-ES' ? SPANISH_TERMS_CONDITIONS : translateText.shift());
				}
			},
			error: function(xhr,status,error) {
				var errorMessage = xhr.status + ': ' + xhr.statusText + 'app/embed/translate.php';
				console.log(errorMessage);
			}
		});
	}
}

function translateMenu(_language) {

	var menuText = [];
	//$('.btn','.faq-content').not('.faq-content .faq-content-main .faq-content-popular').each(function() {
	$('.btn','.faq-content').each(function() {
		if ($(this).data('text')) {
			//console.log('Text: ' + $(this).data('text'));
			menuText.push($(this).data('text'));
		}
        else {
        	//console.log('Text: ' + $(this).data('postback'));
			menuText.push($(this).data('postback'));
		}
	});

	// menuText.push($('.btn-previous','.header_text').data('text'));
	// menuText.push($('.btn-previous','.chat-header').data('text'));
	// menuText.push($('.btn-restart').data('text'));
	menuText.push($('.control-textarea').data('text'));
	menuText.push($('.offcanvas-text').data('text'));
	menuText.push($('.offcanvas-cancel').data('text'));
	menuText.push($('.faq-content-footer-heading').data('text'));
	menuText.push($('.btn-composer-submit').data('text'));

	// click to call text
	menuText.push($(".click-call-trigger.trigger-header-text").data('text'));
	menuText.push($(".click-call-trigger.trigger-menu").data('text'));
	menuText.push($(".text:nth-of-type(1)", ".click-call-controls").data('text'));
	menuText.push($(".text:nth-of-type(2)", ".click-call-controls").data('text'));
	menuText.push($(".contactFname", ".click-call-controls").data('text'));
	menuText.push($(".contactLname", ".click-call-controls").data('text'));
	menuText.push($(".contactPhone", ".click-call-controls").data('text'));
	menuText.push($(".btnText", ".click-call-controls").data('text'));
	menuText.push($(".text:nth-of-type(1)", ".click-call-unavailable").data('text'));
	menuText.push($(".text:nth-of-type(2)", ".click-call-unavailable").data('text'));
	menuText.push($(".consent-text", ".click-call-consent").data('text'));
	menuText.push($(".policyButton", ".click-call-consent").data('text'));

	if (_language !== 'en-US') {
    	translateMenuItems(menuText, _language);
    }
	else {
		//$('.btn','.faq-content').not('.faq-content .faq-content-main .faq-content-popular').each(function() {
		$('.btn','.faq-content').each(function() {
			$(this).text(menuText.shift());
		});

        // $('.btn-previous','.header_text').html('<span><img src="./lib/fontawesome/svgs/light/long-arrow-left.svg" style="width:20px;height:10px"></span> ' + menuText.shift());
        // $('.btn-previous','.chat-header').html('<span><img src="./lib/fontawesome/svgs/light/long-arrow-left.svg" style="width:20px;height:10px"></span> ' + menuText.shift());
        // $('.btn-restart').text(menuText.shift());
		$('.control-textarea').attr('placeholder', menuText.shift());
        $('.offcanvas-text').attr('placeholder', menuText.shift());
        $('.offcanvas-cancel').text(menuText.shift());
        $('.faq-content-footer-heading').text(menuText.shift());
		$('.btn-composer-submit').html(menuText.shift());

		$(".click-call-trigger.trigger-header-text").html(menuText.shift());
		$(".click-call-trigger.trigger-menu").html(menuText.shift());
		$(".text:nth-of-type(1)", ".click-call-controls").html(menuText.shift());
		$(".text:nth-of-type(2)", ".click-call-controls").html(menuText.shift());
		$(".contactFname", ".click-call-controls").attr('placeholder', menuText.shift());
		$(".contactLname", ".click-call-controls").attr('placeholder', menuText.shift());
		$(".contactPhone", ".click-call-controls").attr('placeholder', menuText.shift());
		$(".btnText", ".click-call-controls").html(menuText.shift());
		$(".text:nth-of-type(1)", ".click-call-unavailable").html(menuText.shift());
		$(".text:nth-of-type(2)", ".click-call-unavailable").html(menuText.shift());
		$(".consent-text", ".click-call-consent").html(menuText.shift());
		$(".policyButton", ".click-call-consent").html(menuText.shift());
	}
}


function isValidEmailAddressFormat(emailAddress) {
	//var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;


	//From the W3 HTML5 SPEC https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
	var pattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return pattern.test(emailAddress);
}

function isValidPhoneNumberFormat(number) {
	if (!number) return false
	
	number = number.replace(/[^0-9]/g, '');
	if (number.length != 10)
		return false;
	else
		return true;
}

function updateHeight() {
	if (theme == 'classic')
		return;
	
	var newHeight = 0;
	var controlHeight = $('.composer').outerHeight(true) + 24;
	var messagesHeight = $('.messages').outerHeight(true);
	var headerHeight = $('.chat-header').outerHeight(true);
	
	console.log(controlHeight + ',' + messagesHeight + ',' + headerHeight);
	
	newHeight = controlHeight + messagesHeight + headerHeight;
	parent.postMessage("resizeIframe:"+newHeight,'*');
}
var qs=window.location.search;
var raw=getUrlParameter(qs,'raw');
var theme = getUrlParameter(qs,'theme');
if (raw == 'yes') 
	$(window).resize(function(){
		updateHeight();
	});

function animateModernOut(afterTransition) {
	$('.conversation').animate( {left: "-600px", opacity: "0"}, _MODERN_ANIMATION_LENGTH, _MODERN_DEPART_ANIMATION_EASING, function() {
		$(".step-active").addClass("step-prev").removeClass("step-active");
		if(afterTransition)
			afterTransition.forEach(function(action) { action() } );
		else if (raw === 'yes')
			updateHeight();
	} );
}

function animateModernIn(afterTransition) {
	$('.conversation').css("left" , "600px");
	$(".step-next").addClass("step-active").removeClass("step-next");
	$('.conversation').animate( {left: "0px", opacity: "1"}, _MODERN_ANIMATION_LENGTH, _MODERN_ARRIVE_ANIMATION_EASING, function() {
		if(afterTransition)
			afterTransition.forEach(function(action) { action() } );
		else if (raw === 'yes')
			updateHeight();
	} );
}

function animateModernInReverse(afterTransition) {
	$('.btn-primary').prop('disabled', true);
	$('.conversation').animate( {left: "600px", opacity: "0"}, _MODERN_ANIMATION_LENGTH, _MODERN_DEPART_ANIMATION_EASING, function() {
		$('.btn-primary').prop('disabled', false);
		var activeStep = $(".step-container .step-active");
		activeStep.remove();
		$('.controls .step-active').remove();
		if(afterTransition)
			afterTransition.forEach(function(action) { action() } );
		else if (raw === 'yes')
			updateHeight();
	} );
}

function animateModernOutReverse(afterTransition) {
	$('.conversation').css("left" , "-600px");
	var prevStep = $(".step-container .step-prev").last();
	prevStep.addClass("step-active").removeClass("step-prev");
	$('.controls .step-prev').last().addClass('step-active').removeClass('step-prev');
	$('.conversation').animate( {left: "0px", opacity: "1"}, _MODERN_ANIMATION_LENGTH, _MODERN_ARRIVE_ANIMATION_EASING, function() {
		if(afterTransition)
			afterTransition.forEach(function(action) { action() } );
		else if (raw === 'yes')
			updateHeight();
	} );
}


function timeToDate(time) {
    var splitTime = time.split(':');
    var timeHour = parseInt(splitTime[0]);
    var timeMin = parseInt(splitTime[1]);
    var newDate = new Date();
    return newDate.setHours(timeHour, timeMin, 0);
}

function currentTimeInRange(endTime, timezone) {
    var end = timeToDate(endTime);
    var currentTime = convertTimezone(timezone);

    if (currentTime < end || endTime === '')
        return true;
    return false;
}

function convertTimezone(timezone) {
    var timezoneString = '';
    switch (timezone) {
        case "est":
            timezoneString = "America/New_York";
            break;
        case "mtn":
            timezoneString = "America/Denver";
            break;
        case "pst":
            timezoneString = "America/Los_Angeles";
            break;
        case "ak":
            timezoneString = "America/Anchorage";
            break;
        case "hi":
            timezoneString = "Pacific/Honolulu";
            break;
        default:
            timezoneString = "America/Chicago";
    }
    return new Date((new Date()).toLocaleString("en-US", {timeZone: timezoneString}));   
}
